module.exports = __webpack_public_path__ + "img/py.e6a6e396.svg";